import { render } from "./cards_list_item.vue?vue&type=template&id=1dc4cd62"
import script from "./cards_list_item.vue?vue&type=script&lang=js"
export * from "./cards_list_item.vue?vue&type=script&lang=js"

import exportComponent from "/home/sophia/sophia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__